import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoices/:salesInvoiceId/installments/:installmentId/settle`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const settleInstallment = {
  post: apiPathFunc(pathBase),
};
